export default "__VITE_ASSET__BNg6B3M___"